import React, { useEffect, useState, useMemo } from "react";
import { useSelector, useDispatch } from "react-redux";
import Loader from "../../components/loader";
import Error500 from "../errors/Error500";
import { useLocation } from "react-router-dom";
import menuService from "@services/menuService";
import useSettings from "@hooks/useSettings";
import Error404 from "@routes/errors/Error404";
import { getActionGroups, getMyProjectPermissions, resetProjectPermissions } from "@modules/rolesManagement_v2";
import useCheckPermission from "@hooks/useCheckPermission";
import AccessDenied from "@routes/errors/Error403";
import { capitalize } from "@utils/convert-string";

const Roles = ({ children, ...props }) => {
    const dispatch = useDispatch();
    const location = useLocation();
    const token = useSelector(({ token }) => token);
    const projectPermissions = useSelector(({ roleManagementV2 }) => roleManagementV2?.projectPermissions);

    const { navigatorMenus } = useSettings({ type: "General" });
    const { spaceId, projectId } = menuService.parse(location.pathname);

    const isAdminSetting = useMemo(() => {
        if (!location.pathname) return false;

        return location.pathname.indexOf(`/admin/spaces/${spaceId}`) !== -1 && !projectId;
    }, [location]);

    const isSetting = useMemo(() => {
        if (!location.pathname) return false;
        return location.pathname.indexOf(`/admin/spaces/${spaceId}`) !== -1;
    }, [location]);

    useEffect(async () => {
        if (projectPermissions.pending) return;
        await dispatch(getMyProjectPermissions());
    }, [location.pathname]);

    if (
      location.pathname.indexOf("/access-token-bridge") !== -1 ||
      location.pathname.indexOf("/snsLogin/youtube") !== -1
    ) {
        return <>{children}</>;
    }
    if (projectPermissions.pending || (!isSetting && !navigatorMenus)) {
        return <Loader />;
    } else if (!projectPermissions.pending && projectPermissions.error && global.errorStatus === 500) {
        return <Error500 />;
    } else if (
        props.connectedMenuId &&
        (navigatorMenus?.[props.connectedMenuId]?.visible === undefined ||
            navigatorMenus?.[props.connectedMenuId]?.visible === false)
    ) {
        return <Error404 />;
    } else {
        return <>{children}</>;
    }
};

export default Roles;
